import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { ReactComponent as UnauthorizedIcon } from '../../assets/images/layout/ErrorUnauthorized-rafiki.svg';
import "../../scss/pages/subscription.css";

const Unauthorized = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <>
      <div className="unauthWrap">
        <UnauthorizedIcon />
        <h5>{t("unauthorized.title")}</h5>
        <p>{t("unauthorized.content")}</p>
      </div>
      <div className="subsWrapper">
        <div className="plnaBtn">
          <button onClick={() => navigate("/")}>{t("unauthorized.btn")}</button>
        </div>
      </div>
    </>
  );
};

export default Unauthorized;
